<ng-template #buttonTmpl>
  <div class="nordic-blue-25-bg surface-secondary">
    <ng-content select="[buttons]" />
  </div>
</ng-template>

@if (showDrawer$ | async) {
  <div class="drawer-overlay" @overlayInOut></div>
  <dialog
    (fcomClickOutside)="open.set(false)"
    class="drawer flex flex--column no-outline border-none"
    [class.rounded-top-large]="direction() === DrawerDirection.FROM_BOTTOM"
    [attr.aria-labelledby]="drawerTitleId"
    [attr.aria-describedby]="drawerDescriptionId"
    [ngClass]="direction()"
    fcomTrapFocus
    [@sliderInOut]="direction()"
  >
    <header
      class="modal-header flex--nogrow flex--basis-header flex flex--row flex--center fill relative white-bg surface-primary"
    >
      <h2
        #drawerHeading
        [id]="drawerTitleId"
        data-testid="drawer-title"
        class="font-heading-3 flex-1 truncate overflow-hidden nordic-blue-900-text text-icon-primary pr-large-x pr-xsmall-y font-headline-small"
        tabindex="-1"
      >
        {{ title() }}
      </h2>
      <fcom-icon-button
        class="close-button flex--nogrow flex--self-stretch pr-large-x pr-xsmall-y"
        [icon]="{ name: SvgLibraryIcon.CLOSE_DELETE }"
        [theme]="closeButtonTheme()"
        [aria]="{ label: ariaClose() }"
        [title]="ariaClose()"
        (clickBtn)="open.set(false)"
      />
    </header>
    <div
      class="flex flex-1 scroll white-bg surface-primary"
      [attr.id]="drawerDescriptionId"
      data-testid="drawer-content"
    >
      <ng-content />
    </div>

    @if (showButtons()) {
      <ng-container *ngTemplateOutlet="buttonTmpl" />
    }
  </dialog>
}
